// extracted by mini-css-extract-plugin
export default {"quizHeader":"BarHeader_quizHeader__ckbZl"};